import { ReactElement } from "react";
import HubAreaList from "../../components/Hubs/Areas";
import Layout from "../../components/layout";

const HubAreaPage = (): ReactElement => {
  return (
    <Layout>
      <HubAreaList />
    </Layout>
  );
};

export default HubAreaPage;
